import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';
import { isMobile, isTabletDown } from './isMobile';

gsap.registerPlugin(ScrollTrigger);

export function HeroThirdScene() {
    let tl = gsap.timeline({
        scrollTrigger: {
            trigger: '.hero-second-scene',
            start: () => '100% top',
            end: () => '+=50%',
            scrub: 1,
        }
    });

    tl
        .set('.hero-second-scene', { zIndex: 4, pointerEvents: 'none' });
    if (!isTabletDown()) {
        tl
            .to('.hero-third-scene__grid', 1, { y: () => '-=80vh' });
    } else {
        tl
            .to('.hero-second-scene__circle-graphics', 1, { autoAlpha: 0, pointerEvents: 'none' }, '-=1')
            .to('.hero__clip-container', 1, { autoAlpha: 0 }, '-=1')
            .to('.hero-third-scene__grid', 3, { y: () => '-=50vh', autoAlpha: 0 }, '-=1')
            .set('.third-section', { zIndex: 4 })
            .set('.hero-second-scene', { zIndex: 6 });
    }
}